import { Component, OnInit, Inject } from '@angular/core';
import { MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { ISiteContact } from 'src/app/core/models/site/ISiteContact';

@Component({
    selector: 'app-bottom-sheet-contact',
    templateUrl: './bottom-sheet-contact.component.html',
    styleUrls: ['./bottom-sheet-contact.component.scss'],
    standalone: false
})
export class BottomSheetContactComponent implements OnInit {

  phone1: string = '';
  phone2: string = '';
  email: string = '';
  constructor(@Inject(MAT_BOTTOM_SHEET_DATA) public data: any,
    private _bottomSheetRef: MatBottomSheetRef<BottomSheetContactComponent>) {}

  ngOnInit() {


    this.phone1 = 'tel:' + this.data.phone1;
    this.phone2 = 'tel:' + this.data.phone2;
    this.email = 'mailto:' + this.data.email;
  }

  logPhone(phone: string) {

    // if (this.data.log) {
    //   let text = `Kontakt med ${this.data.name} har inletts via telefon (${phone})`;
      
    //   this.soBL.addInternalText(this.data.so, text).subscribe(x => {
    //     this._bottomSheetRef.dismiss({ log: true, text: text });
    //   });
    // }
    // else {
    //   this._bottomSheetRef.dismiss();
    // }
    this._bottomSheetRef.dismiss();
  }

  logMail(mail: string) {
    // if (this.data.log) {
    //   let text = `Kontakt med ${this.data.name} har inletts via mail (${mail})`;
      
    //   this.soBL.addInternalText(this.data.so, text).subscribe(x => {
    //     this._bottomSheetRef.dismiss({ log: true, text: text });
    //   });
    // }
    // else {
    //   this._bottomSheetRef.dismiss();
    // }
    this._bottomSheetRef.dismiss();
  }
}